var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_9394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.04297 15.1211H22.293C22.8555 15.1211 23.3359 14.6406 23.3359 14.0664C23.3359 13.4922 22.8555 13.0234 22.293 13.0234H5.04297C4.48047 13.0234 4 13.4922 4 14.0664C4 14.6406 4.48047 15.1211 5.04297 15.1211Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_9394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3359,
    height: 2.12109,
    fill: "white",
    transform: "translate(4 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.152562f136596bdd51de1a71e6f16278.svg";
export { ForwardRef as ReactComponent };